import CoursesBlock from './CoursesBlock';
import { CoursesBlockProps, CoursesBlockValueProps } from './types';

export type { CoursesBlockProps, CoursesBlockValueProps };
export default CoursesBlock;
